"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BASE_TOGGLE_CLASS_NAME = void 0;
exports.BASE_TOGGLE_CLASS_NAME = "monday-style-toggle";
